import { toast as reactToastify } from 'react-toastify';

// Base toast configuration
const BASE_TOAST_CONFIG = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  icon: false, // Remove default icons (no green checkmark)
};

// Dark toast style (dark background, light text)
export const defaultDarkToastStyle = {
  ...BASE_TOAST_CONFIG,
  className: 'toast-dark',
  style: {
    background: '#333',
    color: '#fff',
    border: '2px solid #555',
    borderRadius: '8px',
    fontWeight: '500',
  },
};

// Primary toast style (team color background, white text, white border)
// Uses CSS variables set by App.jsx based on team colors
export const defaultPrimaryToastStyle = {
  ...BASE_TOAST_CONFIG,
  className: 'toast-primary',
  style: {
    background: 'var(--toast-bg-color, #ff1744)', // Fallback to pink/red
    color: '#fff',
    border: '2px solid #fff',
    borderRadius: '8px',
    fontWeight: 'normal',
  },
};

// Default to primary style for all toasts
const TOAST_CONFIG = defaultPrimaryToastStyle;

// Centralized toast helper functions
export const toast = {
  success: (message, options = {}) =>
    reactToastify.success(message, {
      ...TOAST_CONFIG,
      ...options,
    }),

  error: (message, options = {}) => {
    // Add "An error occurred. " prefix only if the word "error" is not already in the message
    const hasErrorWord = /\berror\b/i.test(message);
    const formattedMessage = hasErrorWord
      ? message
      : `An error occurred. ${message}`;
    return reactToastify.error(formattedMessage, {
      ...TOAST_CONFIG,
      ...options,
    });
  },

  info: (message, options = {}) =>
    reactToastify.info(message, {
      ...TOAST_CONFIG,
      ...options,
    }),

  warning: (message, options = {}) =>
    reactToastify.warning(message, {
      ...TOAST_CONFIG,
      ...options,
    }),
};

// Export config for backward compatibility
export const DEFAULT_TOAST_OPTIONS = TOAST_CONFIG;
